import { render, staticRenderFns } from "./CompSocialNetworkShare.vue?vue&type=template&id=76353fc4&scoped=true"
import script from "./CompSocialNetworkShare.vue?vue&type=script&setup=true&lang=js"
export * from "./CompSocialNetworkShare.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompSocialNetworkShare.vue?vue&type=style&index=0&id=76353fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76353fc4",
  null
  
)

export default component.exports